import { capitalizeFirstLetter } from '../../utils/textFormat';

/**
 * Generic sidebar list item component for admin sections
 * Uses theme variables for consistent color theming
 */
export default function SidebarListItem({
  isSelected,
  onClick,
  onContextMenu,
  title,
  statusBadge,
  badges = [],
  isActive = true
}) {
  // Capitalize first letter of title
  const capitalizedTitle = capitalizeFirstLetter(title);

  const handleContextMenu = (e) => {
    if (onContextMenu) {
      e.preventDefault();
      e.stopPropagation();
      onContextMenu(e);
    }
  };

  return (
    <button
      onClick={onClick}
      onContextMenu={handleContextMenu}
      className={`w-full rounded-lg border transition-all duration-200 relative text-left p-3 max-lg:p-2 ${
        isSelected
          ? 'shadow-lg'
          : ''
      }`}
      style={
        isSelected
          ? {
              backgroundColor: 'var(--color-bg-elevated)',
              borderColor: 'var(--color-accent-primary)',
              borderWidth: '2px'
            }
          : {
              backgroundColor: 'transparent',
              borderColor: 'var(--color-border-default)',
              borderWidth: '1px'
            }
      }
    >
      <div className="flex items-center justify-between mb-1.5 max-lg:mb-1">
        <div className="font-medium text-sm max-lg:text-xs truncate">
          <span style={{ color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-muted)' }}>
            {capitalizedTitle}
          </span>
        </div>
        {statusBadge}
      </div>
      {badges.length > 0 && (
        <div className="flex items-center gap-2 max-lg:gap-1 min-w-0 overflow-hidden">
          {badges.map((badge, index) => (
            <span key={index} className="min-w-0 flex-shrink">{badge}</span>
          ))}
        </div>
      )}
    </button>
  );
}
